import { render } from "./MaoSideBar.vue?vue&type=template&id=3a72ed8d&scoped=true"
import script from "./MaoSideBar.vue?vue&type=script&lang=js"
export * from "./MaoSideBar.vue?vue&type=script&lang=js"

import "./MaoSideBar.vue?vue&type=style&index=0&id=3a72ed8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a72ed8d"]])

export default __exports__